import policy from "./retentionPolicy.json" with { type: "json" };

export const DEFAULT_COMPANY_RETENTION_DAYS =
	policy.defaultCompanyRetentionDays;
